class Countries {
    static findByCode(code) {
        return this.raw.find((item) => item.code === code);
    }
    static findByCurrencyCode(currencyCode) {
        return this.raw.find((item) => item.currency.code === currencyCode);
    }
    static formatAmount(value, currencyCode = 'AUD', short = false) {
        value = value || 0;
        const country = this.findByCurrencyCode(currencyCode);
        return [
            `${country === null || country === void 0 ? void 0 : country.currency.symbol}${value}`,
            ...(short ? [] : [`${country === null || country === void 0 ? void 0 : country.currency.code}`]),
        ].join(' ');
    }
    static splitMobile(whole) {
        if (typeof whole !== 'string') {
            return {};
        }
        const trimmedWhole = whole.replace(/^0/, '');
        const targetCountry = this.raw.find((country) => trimmedWhole.startsWith(country.areaCode));
        if (!targetCountry) {
            return { number: whole };
        }
        const { areaCode } = targetCountry;
        return {
            areaCode,
            number: trimmedWhole.slice(areaCode.length),
        };
    }
}
Countries.raw = [
    {
        name: 'Australia',
        code: 'AU',
        bn: {
            name: 'ABN',
            field: 'abn',
        },
        currency: {
            code: 'AUD',
            symbol: '$',
        },
        flag: '🇦🇺',
        areaCode: '61',
    },
    {
        name: 'United Arab Emirates',
        code: 'AE',
        currency: {
            code: 'AED',
            symbol: 'د.إ',
        },
        flag: '🇦🇪',
        areaCode: '971',
    },
    {
        name: 'India',
        code: 'IN',
        currency: {
            code: 'INR',
            symbol: '₹',
        },
        flag: '🇮🇳',
        areaCode: '91',
    },
    {
        name: 'Korea Republic',
        code: 'KR',
        currency: {
            code: 'KRW',
            symbol: '₩',
        },
        flag: '🇰🇷',
        areaCode: '82',
    },
    {
        name: 'New Zealand',
        code: 'NZ',
        bn: {
            name: 'NZBN',
            field: 'business_registration_number',
        },
        currency: {
            code: 'NZD',
            symbol: '$',
        },
        flag: '🇳🇿',
        areaCode: '64',
    },
    {
        name: 'Singapore',
        code: 'SG',
        currency: {
            code: 'SGD',
            symbol: 'S$',
        },
        flag: '🇸🇬',
        areaCode: '65',
    },
    {
        name: 'United Kingdom',
        code: 'UK',
        currency: {
            code: 'GBP',
            symbol: '£',
        },
        flag: '🇬🇧',
        areaCode: '44',
    },
    {
        name: 'United States',
        code: 'US',
        currency: {
            code: 'USD',
            symbol: '$',
        },
        flag: '🇺🇸',
        areaCode: '1',
    },
];

export { Countries };
